
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.591.083A1.59 1.59 0 00.545.546a1.59 1.59 0 000 2.245L6.76 9.005.545 15.219a1.59 1.59 0 000 2.244 1.59 1.59 0 002.245 0l6.214-6.213 6.213 6.213a1.59 1.59 0 002.245 0 1.59 1.59 0 000-2.244L11.25 9.005l6.213-6.214a1.59 1.59 0 000-2.245 1.59 1.59 0 00-1.199-.463 1.59 1.59 0 00-1.046.463L9.004 6.76 2.79.546A1.59 1.59 0 001.591.083z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    